import Vue from 'vue';
import { EC_ENV_PROD } from './params';
import Navbar from './components/navbar/Navbar';
import store from './store/navbar';
import { BootstrapVue } from 'bootstrap-vue';
import {SET_ACCOUNT_NAME, SET_PATH, SET_PROJECT_ID, SET_NAVBAR_LOGO_URL, SET_NAVBAR_MANU_COLOR, SET_NAVBAR_IS_GUEST, SET_NAVBAR_USER,
	SET_NAVBAR_IS_MAIN_DOMAIN, SET_NAVBAR_IS_SUPER_ADMIN, SET_NAVBAR_FREE_TRIAL_NOT_EXPIRED} from "@/store/navbar/mutations";
import {getData} from "@/utils/before-mount";
import RippleDirective from './directives/Ripple';
import OutsideClick from "@/directives/OutsideClick";

Vue.use(BootstrapVue);
Vue.directive('ripple', RippleDirective);
Vue.directive('outside-click', OutsideClick);

const navbarVm = new Vue({
	el: '#navbar-vue',
	store,
	components: {
		Navbar
	},
	beforeMount() {
		const {projectId, path, accountName, isMainDomain} = getData();
		this.$store.commit(SET_PATH, path);
		this.$store.commit(SET_PROJECT_ID, projectId);
		this.$store.commit(SET_ACCOUNT_NAME, accountName);
		this.$store.commit(SET_NAVBAR_IS_MAIN_DOMAIN, isMainDomain);
		this.$store.commit(SET_NAVBAR_MANU_COLOR, this.$el.dataset.menuColor);
		this.$store.commit(SET_NAVBAR_LOGO_URL, this.$el.dataset.logoUrl);
		this.$store.commit(SET_NAVBAR_IS_GUEST, !!this.$el.dataset.isGuest);
		this.$store.commit(SET_NAVBAR_IS_SUPER_ADMIN, !!this.$el.dataset.isSuperAdmin);
		this.$store.commit(SET_NAVBAR_FREE_TRIAL_NOT_EXPIRED, this.$el.dataset.freeTrialNotExpired);
		if (this.$el.dataset.user) {
			this.$store.commit(SET_NAVBAR_USER, JSON.parse(this.$el.dataset.user));
		}
	},
	template: '<Navbar/>',
});

Vue.config.devtools = EC_ENV !== EC_ENV_PROD;

export default navbarVm;
